import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const id = params.get("session_id");
    let tries = 0;
    const t = setInterval(async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${id}`);
        if (data.payment_status === "paid") { setState("paid"); return clearInterval(t); }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return clearInterval(t); }
      } catch { /* keep polling */ }
      if (tries > 15) { setState("timeout"); clearInterval(t); }
    }, 2000);
    return () => clearInterval(t);
  }, [params]);

  return (
    <div className="max-w-lg mx-auto panel p-8 text-center space-y-4 mt-10" data-testid="payment-result" data-state={state}>
      {state === "checking" && <><Loader2 className="h-10 w-10 mx-auto text-amber-400 animate-spin" /><h1 className="text-2xl font-bold">Confirming your payment...</h1></>}
      {state === "paid" && <><CheckCircle2 className="h-10 w-10 mx-auto text-emerald-400" /><h1 className="text-2xl font-bold">Payment received. You're all set!</h1>
        <Link to="/program" className="text-emerald-400 hover:text-emerald-300" data-testid="payment-continue-link">Go to Race Program →</Link></>}
      {state !== "checking" && state !== "paid" && <><XCircle className="h-10 w-10 mx-auto text-rose-400" /><h1 className="text-2xl font-bold">{state === "failed" ? "Payment didn't go through" : "Still confirming, check back shortly"}</h1>
        <Link to="/subscribe" className="text-emerald-400">Back to plans</Link></>}
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="max-w-lg mx-auto panel p-8 text-center space-y-4 mt-10" data-testid="payment-cancel">
      <XCircle className="h-10 w-10 mx-auto text-slate-400" />
      <h1 className="text-2xl font-bold">Checkout cancelled</h1>
      <p className="text-slate-400 text-sm">No payment was taken.</p>
      <Link to="/subscribe" className="text-emerald-400" data-testid="payment-back-link">Back to plans</Link>
    </div>
  );
}
